import './Header.scss';
import React from 'react';

const LandingHeader = () => (
    <div className="header">
        <div>
            <div className="logo" />
        </div>
    </div>
);

export default LandingHeader;
